
let url = /meituan/i.test(location.host) ? 'https://g.meituan.com/wed/event/other/wizardAjaxAction' : 'https://h5.dianping.com/wed/event/other/wizardAjaxAction';
let GetQueryString = require('@lib/getQueryString');
var eventId = GetQueryString('eventid') || '';
// var htmlPath = 'https://' + location.host + '/app/app-wedding-peon/act/qing_ren/';
let Env = require('@lib/env');
let comprehensiveLinkMt = 'http://tpl.dianping.com/firework/callApp?type=meituan&appurl=imeituan%3A%2F%2Fwww.meituan.com%2Fweb%3Furl%3Dhttps%253a%252f%252fg.meituan.com%252fapp%252fapp-wedding-peon%252fact%252fmarch_promotion%252findex_page.html&weburl=https%3A%2F%2Fg.meituan.com%2Fapp%2Fapp-wedding-peon%2Fact%2Fmarch_promotion%2Findex_page.html%3FisTuneup%3Dyes';
let comprehensiveLinkDp = 'https://evt.dianping.com/synthesislink/11146.html';
let linkEnd = "";
Env.isDPM ? linkEnd = comprehensiveLinkDp : linkEnd = comprehensiveLinkMt;
// env.isApp
//762
const data = {
    action: 'wedPromotionCPC1704',
    eventId: eventId ? eventId : 791,
    categoryIds: 163,
    link : linkEnd
    // source: (Env.isDPApp || Env.isMTApp) ? 2 : 3
}

const url_Ad = /meituan/i.test(location.host) ? 'https://api-baymax-adp.meituan.com/midasmkt/mtajax/promotionPageAds' : 'https://baymax-api.dianping.com/midasmkt/ajax/dpActivityAds';
const slotIds = /meituan/i.test(location.host) ? 59001 : 10045;
const categoryIds = /meituan/i.test(location.host) ? 20198 : 163;
const utm_sourceLink = GetQueryString('utm_source') || "WEIXIN_LINK";
let phoneTypes = "";
Env.isIOS ? phoneTypes = "ios" : phoneTypes = "android";
const data_Ad ={
    acid :  eventId ? eventId : 791,
    slotId : slotIds,
    cityId : "",
    shopType : 55,
    categoryIds : categoryIds,
    // dpid : "",
    lng :"",
    lat :"",
    phoneType :phoneTypes,
    utm_source :utm_sourceLink
}
export { url, data , url_Ad, data_Ad}


// WEBPACK FOOTER //
// ./src/act/march_promotion/api/url.js